
export default {
  fetch(key) {
    var value = window.sessionStorage.getItem(key)
    return value ? JSON.parse(value) : ''
  },
  save(key,value) {
    if(value) {
      window.sessionStorage.setItem(key, JSON.stringify(value))
    } else {
      window.sessionStorage.removeItem(key);
    }
  }
}
